var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcanaIconWalletSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26.5,
    stroke: "#bf96ff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9753 13.1141C28.8538 13.125 31.7496 14.0652 34.1773 15.9913C39.9128 20.5415 40.864 28.8669 36.3016 34.5871C31.7392 40.3072 23.3914 41.2559 17.6559 36.7057C15.2282 34.7796 13.6582 32.1773 13 29.3824C13.398 33.2142 15.28 36.8902 18.5419 39.4782C24.9794 44.5851 34.3489 43.5208 39.4695 37.1006C44.5901 30.6804 43.523 21.3358 37.0856 16.2289C33.8236 13.641 29.8094 12.6392 25.9758 13.1141H25.9753Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5987 36.7067L31.6086 37.5604L31.7573 36.6694L32.5987 36.7067L33.0067 36.9539L32.9574 35.9395L32.5987 36.7067Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0067 36.954L31.6086 37.5605L32.5987 36.7068L33.0067 36.954Z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9574 35.9395L31.7573 36.6694L32.5987 36.7067L32.9574 35.9395Z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7337 40.2327L26.3904 40.5203L26.6875 41.5318L26.7337 40.2327Z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7338 40.2329L27.1328 40.5484L26.6875 41.532",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6404 36.9817L26.2173 41.4545L25.9297 40.0624L20.6404 36.9817Z",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2173 41.4548L22.1623 39.9328L20.6404 36.9819L22.8116 39.6263L26.2173 41.4548Z",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9297 40.0627L25.4844 39.3666L20.6404 36.9819L22.8116 39.6263L22.1623 39.9328L20.6404 36.9819L22.8116 39.6263L26.2173 41.4548L25.9297 40.0627Z",
    fill: "none"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2173 41.4545L20.6404 36.9817L25.9297 40.0624L26.2173 41.4545Z",
    fill: "none"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6404 36.9817L22.8116 39.6261L22.1623 39.9326L20.6404 36.9817Z",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3229 36.3715L29.4155 36.1396L30.4364 35.8242L31.1414 35.9819L30.8076 37.077L29.7036 36.9283L29.3229 36.3715Z",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4364 35.8242L29.7036 36.9283L31.1414 35.9819",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8076 37.0776L28.5433 38.5065L29.3229 36.3721L29.7035 36.9288L28.5433 38.5065L29.7035 36.9288L30.8076 37.0776Z",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7035 36.9282L28.5433 38.5059L30.8076 37.077L29.7035 36.9282Z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6784 39.8992L34.3122 41.5838V40.8211L35.6784 39.8992Z",
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3122 41.5834L29.9259 41.8536L34.3122 40.8207L33.5017 39.7241L35.6784 39.8987L34.3122 40.8207V41.5834Z",
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9259 41.8536L33.5017 39.7241L34.3122 40.8207L29.9259 41.8536Z",
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8187 28.7344L24.7446 29.4767L25.0232 29.9314L25.3202 29.2822L24.8187 28.7344Z",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8187 28.7344L24.9491 29.421L25.3202 29.2822",
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7446 29.4764L24.9491 29.4207L25.0232 29.9311",
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 33.9411L24.2645 32.3167L25.0486 33.5386L24.5197 33.4849L24.1406 33.9411Z",
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2645 32.3167L24.5197 33.4849L25.0073 34.8282L25.0486 33.5386L25.0073 34.8282L24.1406 33.9411L24.5197 33.4849L25.0486 33.5386",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0486 33.5386L24.5197 33.4849L25.0073 34.8282",
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1178 24.1394L25.7307 25.3315L26.0571 26.1022L26.7228 25.2897L26.1178 24.1394Z",
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1178 24.1392L26.2855 24.9666L26.7228 25.2895L26.1178 24.1392Z",
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7307 25.3315L26.2855 24.9668L26.0571 26.1022L25.7307 25.3315Z",
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6871 33.6145L29.6224 34.4683L29.8727 34.7927L30.0861 34.2548L29.6871 33.6145Z",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0861 34.2548L29.6871 33.6145L29.8359 34.3568L30.0861 34.2548L29.8359 34.3568L29.6224 34.4683L29.8359 34.3568L29.8727 34.7927L29.6224 34.4683L29.6871 33.6145",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8727 34.7922L30.0861 34.2544L29.8359 34.3564L29.8727 34.7922Z",
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6224 34.4686L29.8359 34.3572L29.8727 34.793",
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6871 33.6143L29.8359 34.3566L30.0862 34.2546",
    fill: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8578 30.1953L28.6418 32.2631L28.3313 32.6019L28.1373 30.5958L28.5731 30.8068L29.8578 30.1953Z",
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5731 30.8061L28.4875 29.813L28.1373 30.5951L28.5731 30.8061L29.8578 30.1946L29.0831 29.1289",
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8577 30.1946L28.6418 32.2624L28.3313 32.6012L28.5731 30.8061L29.0831 29.1289L28.4875 29.813L28.5731 30.8061",
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6418 32.2627L28.5731 30.8064L28.3313 32.6015L28.6418 32.2627Z",
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8051 28.7795L32.3425 29.4109L32.4673 29.5099L32.4007 28.8397L32.2703 28.9278L31.8051 28.7795Z",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2703 28.9276L32.234 28.5963L32.4007 28.8396L32.2703 28.9276L31.8051 28.7794L31.9922 28.3953",
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8051 28.7794L32.3425 29.4107L32.4673 29.5097L32.2703 28.9276L31.9922 28.3953L32.234 28.5963L32.2703 28.9276",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3425 29.4111L32.2703 28.928L32.4674 29.5101L32.3425 29.4111Z",
    fill: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4045 30.291L19.7483 30.8169L20.203 30.6766L20.4045 30.291Z",
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2041 30.6744L20.3498 30.8764L20.7767 31.47L20.5956 32.4382L20.3732 32.9994L20.218 32.4168L19.4612 31.7561L19.7493 30.8147L20.4056 30.2883L20.2041 30.6744Z",
    fill: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2184 32.4161L19.4617 31.7553L19.8995 32.5693L20.3732 32.9987L20.2184 32.4161L20.7772 31.4693L20.4055 30.2881L20.2184 32.4161Z",
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3732 32.9992L19.8996 32.5698L19.4617 31.7559L20.2185 32.4166L20.3732 32.9992Z",
    fill: "none"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7772 31.4692L20.2185 32.416L20.3732 32.9987L20.5956 32.4379L20.7772 31.4692Z",
    fill: "none"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7493 30.8145L20.2041 30.6742L20.4056 30.2881L19.7493 30.8145Z",
    fill: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4055 30.2881L20.204 30.6742L20.3533 30.8836L20.2185 32.4161L20.7772 31.4693L20.4055 30.2881Z",
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3533 30.8836L20.4055 30.2881L20.204 30.6742",
    fill: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3647 36.042L19.3189 35.5176L19.5965 35.2141L19.3647 36.042Z",
    fill: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9135 35.3133L19.1632 34.8396L19.5966 35.2142L19.1632 34.8396L19.3189 35.5177L18.9135 35.3133L19.3647 36.0421L19.3189 35.5177L19.5966 35.2142L19.3189 35.5177L19.1632 34.8396L19.3189 35.5177L19.5966 35.2142L19.1632 34.8396L18.9135 35.3133Z",
    fill: "none"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3189 35.5177L19.1632 34.8396L18.9135 35.3133L19.3189 35.5177L19.5966 35.2142L19.3189 35.5177Z",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3244 26.0525L29.3712 26.5535L29.807 26.7575L30.1503 26.7948L29.7886 26.2475L29.3244 26.0525Z",
    fill: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6483 26.3444L29.9558 26.0339L29.6483 26.3444L29.3244 26.0524L29.9558 26.0339L30.1503 26.7947",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6483 26.3444L29.9558 26.0339L29.3244 26.0524L29.6483 26.3444L29.3712 26.5534L29.807 26.7574",
    fill: "none"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8151 26.6277L22.2857 27.2402L22.2579 27.6949L22.7683 27.2123L22.5086 27.2402L22.2579 27.6949L22.5086 27.2402H22.2857H22.5086L22.8151 26.6277Z",
    fill: "none"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7683 27.2122L22.5086 27.24L22.2579 27.6948L22.7683 27.2122Z",
    fill: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7683 27.2123L22.8151 26.6277L22.5086 27.2402H22.2857L22.2579 27.6949L22.5086 27.2402L22.7683 27.2123Z",
    fill: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8151 26.6276L22.2863 27.2401H22.5092C22.5092 27.2401 22.8151 26.6162 22.8151 26.6276Z",
    fill: "none"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5812 40.0136L20.2314 39.6648L20.0727 39.6742L21.5812 40.0136Z",
    fill: "none"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9583 38.8018L20.0548 38.0664L19.7737 38.765L19.9583 38.8018L20.2314 39.6655L20.0727 39.6749L19.7737 38.765",
    fill: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2314 39.6655L20.0548 38.0664L19.9583 38.8018L19.7737 38.765L20.0727 39.6749L21.5812 40.0143L21.2743 39.6043L20.5294 38.353L20.0548 38.0664L21.2743 39.6043L20.2314 39.6655L21.5812 40.0143L20.2314 39.6655Z",
    fill: "none"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2314 39.665L19.9583 38.8012L19.7737 38.7644L20.0727 39.6744L20.2314 39.665Z",
    fill: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9583 38.8018L20.2314 39.6655L21.2742 39.6043L20.0548 38.0664L19.9583 38.8018Z",
    fill: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9583 38.8012L20.2314 39.665L20.0727 39.6744L19.7737 38.7644L19.9583 38.8012Z",
    fill: "none"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2743 39.6035L21.2061 39.916L21.5813 40.0135",
    fill: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M25.676 37.7272L26.669 36.3167L25.0729 37.6714L25.676 37.7272L27.7547 37.7461L28.2557 37.551L26.669 36.3167L25.0729 37.6714L25.676 37.7272L26.7248 40.1308L25.0729 37.6714L26.669 36.3167L25.676 37.7272Z",
    fill: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7248 40.1305L25.676 37.7269L27.7547 37.7458L25.676 37.7269L26.669 36.3164L27.7547 37.7458L26.7248 40.1305L28.2557 37.5508L26.7248 40.1305Z",
    fill: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7248 40.1307L25.676 37.7271L27.7547 37.746L26.7248 40.1307Z",
    fill: "none"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.669 36.3164L27.7546 37.7458L28.2557 37.5508L26.669 36.3164Z",
    fill: "none"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.676 37.7272L26.669 36.3167L25.0729 37.6714L26.669 36.3167L25.0729 37.6714L25.676 37.7272L26.669 36.3167L27.7547 37.7461L28.2557 37.551L26.7248 40.1308L27.7547 37.7461L25.676 37.7272Z",
    fill: "none"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0729 37.6709L25.676 37.7266L26.7248 40.1302L25.0729 37.6709Z",
    fill: "none"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.669 36.3167L25.676 37.7272L25.0729 37.6714L26.669 36.3167Z",
    fill: "none"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0311 36.9305L22.64 36.2156L22.9898 37.4127L24.0311 36.9305Z",
    fill: "none"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1425 35.7415L22.6708 37.3973L22.9898 37.4127L22.64 36.2156L22.1425 35.7415Z",
    fill: "none"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.64 36.2156L24.0311 36.9306L24.1401 36.7286L22.1425 35.7415L22.64 36.2156Z",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9897 37.413L24.661 38.4549L24.0311 36.9309L22.9897 37.413Z",
    fill: "none"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.057 38.8356L24.1401 36.729L25.057 38.8356L22.6708 37.3977L22.9898 37.4131L24.661 38.455L25.057 38.8356L24.661 38.455L25.057 38.8356Z",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1425 35.7415L22.6708 37.3973L22.9898 37.4127L22.64 36.2156L22.1425 35.7415Z",
    fill: "none"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1401 36.729L24.0311 36.931L24.661 38.455L25.057 38.8356L24.1401 36.729Z",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 31.1299L33.3888 34.7594L34.5625 33.3753L34.5759 33.3599L34.2018 32.8877L34.4023 32.4235L34.0838 31.7379L33.5042 31.3324L33.35 31.1299Z",
    fill: "none"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5042 31.3328L34.2018 32.8881L34.0838 31.7383",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4023 32.4231L34.4893 32.6739L34.5759 33.3595L34.2018 32.8873L33.3888 34.759L34.5759 33.3595L34.4023 32.4231Z",
    fill: "none"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2018 32.8873L34.4023 32.4231L34.5759 33.3595",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M33.35 31.1299L33.7505 32.9543L33.3888 34.7594L33.35 31.1299Z",
    fill: "none"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7505 32.9543L33.3644 32.8285L33.35 31.1299L33.7505 32.9543Z",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0436 36.8628L33.3739 39.2256L34.7785 38.8798L34.7944 38.8758L34.773 38.3962L35.1193 38.1897L35.2337 37.5982L35.0486 37.0658L35.0436 36.8628Z",
    fill: "none"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0486 37.0657L34.773 38.3961L35.2337 37.598",
    fill: "none"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1193 38.1897L35.0581 38.3922L34.7944 38.8758L34.773 38.3962L33.3739 39.2256L34.7944 38.8758L35.1193 38.1897Z",
    fill: "none"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.773 38.3962L35.1193 38.1897L34.7944 38.8758",
    fill: "none"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0436 36.8628L34.4506 38.2285L33.3739 39.2256L35.0436 36.8628Z",
    fill: "none"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4506 38.2285L34.2595 37.9673L35.0436 36.8628L34.4506 38.2285Z",
    fill: "none"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2516 42.2087L25.1377 42.6914L24.6182 43.9999L25.5153 43.1919L26.2516 42.2087Z",
    fill: "none"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5153 43.1919L26.2516 42.2087L25.1377 42.6914L25.5153 43.1919L24.6182 44.0004L25.9357 43.4436",
    fill: "none"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9357 43.4436L25.5153 43.1919L26.2516 42.2097L25.9357 43.4436L25.5153 43.1919L25.9357 43.4436Z",
    fill: "none"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5786 42.7004L29.7036 42.988L29.5921 43.2945L27.6527 42.9975L27.5786 42.7004Z",
    fill: "none"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8334 42.4595L29.7036 42.9883L27.5786 42.7008L26.7895 42.4968L29.8334 42.4595Z",
    fill: "none"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6527 42.9974L27.5786 42.7004L29.7036 42.9879L29.5921 43.2944L29.7036 42.9879L31.7728 42.58L29.5921 43.2944L27.6527 42.9974L26.7895 42.4964L27.5786 42.7004L26.7895 42.4964L30.2787 41.9302L29.8334 42.4591L29.7036 42.9879L29.8334 42.4591L31.7728 42.58L30.2787 41.9302L29.8334 42.4591L26.7895 42.4964",
    fill: "none"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7728 42.5804L29.8334 42.4595L29.7036 42.9883L31.7728 42.5804Z",
    fill: "none"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8334 42.4591L30.2787 41.9302L26.7895 42.4964L29.8334 42.4591Z",
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1037 42.6646L26.1959 41.9775L22.1683 41.9686L21.8434 40.4839L19.6354 41.0312L22.1683 41.9686L22.1037 42.6646L19.6354 41.0312L21.8434 40.4839L24.7113 41.059L26.1959 41.9775L22.1037 42.6646L26.1959 41.9775L22.1683 41.9686L21.8434 40.4839L19.6354 41.0312L22.1037 42.6646L22.1683 41.9686L19.6354 41.0312",
    fill: "none"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1959 41.9772L22.1036 42.6643L22.1683 41.9683L26.1959 41.9772Z",
    fill: "none"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8434 40.4839L22.1683 41.9686L19.6354 41.0312L21.8434 40.4839Z",
    fill: "none"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7112 41.059L21.8434 40.4839L22.1683 41.9686",
    fill: "none"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8624 38.9637L32.3703 39.1747L32.0037 38.9991L33.6888 37.4478",
    fill: "none"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5737 41.2353L31.2026 38.349L33.6888 37.448L32.84 39.5784L32.8624 38.964L33.6888 37.448L32.0036 38.9993L31.2026 38.349L33.6888 37.448L32.0036 38.9993L31.2026 38.349",
    fill: "none"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5737 41.2356L31.4772 40.6266L31.0369 40.5758L31.4772 40.6266L32.84 39.5788L32.3703 39.1753L31.0369 40.5758L29.5737 41.2356L31.2026 38.3494L32.0036 38.9996L29.5737 41.2356Z",
    fill: "none"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8624 38.9644L32.3704 39.1753L32.84 39.5788L32.8624 38.9644Z",
    fill: "none"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0369 40.5757L32.3703 39.1752L32.0036 38.9995L29.5737 41.2355L31.0369 40.5757Z",
    fill: "none"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9835 39.5235L29.9692 38.2617L29.7095 39.9693L27.9835 39.5235Z",
    fill: "none"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9835 39.5237L26.9626 41.6955L28.698 41.2034L29.7095 39.9695L30.1548 39.9322L29.9692 38.262L27.9835 39.5237Z",
    fill: "none"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0134 41.3051L28.698 41.2031L29.7095 39.9692L30.1548 39.9319L29.0134 41.3051L26.9626 41.6952L28.698 41.2031L29.0134 41.3051Z",
    fill: "none"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7095 39.9693L27.9835 39.5235L29.9692 38.2617L29.7095 39.9693Z",
    fill: "none"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0134 41.3049L28.698 41.2029L26.9626 41.695L29.0134 41.3049Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcanaIconWalletSend);
export default __webpack_public_path__ + "static/media/arcana_icon_wallet_send.c37564217c07f950dac85cdeec24b77e.svg";
export { ForwardRef as ReactComponent };